import React, { useState, useEffect, useRef } from 'react';
import BigButton from '../bigButton/BigButton';
import '../header/header.css';
import Nav from '../nav/Nav';
import Logo from '../../assets/logo_500px.svg';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
    const navigate = useNavigate();
    const headerRef = useRef<HTMLDivElement>(null);

    const [headerBottom, setHeaderBottom] = useState<number>(0);
    const [isSticky, setIsSticky] = useState<boolean>(false);
    const [lightBackground, setLightBackground] = useState<boolean>(false);
    const [visible, setVisible] = useState<boolean>(true);
    const prevScrollY = useRef<number>(window.scrollY);

    useEffect(() => {
        const updateHeaderBottom = () => {
            if (headerRef.current) {
                setHeaderBottom(headerRef.current.offsetHeight);
            }
        };
        updateHeaderBottom();
        window.addEventListener('resize', updateHeaderBottom);
        return () => window.removeEventListener('resize', updateHeaderBottom);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const direction = scrollY > prevScrollY.current ? 'down' : 'up';
            prevScrollY.current = scrollY;

            if (scrollY === 0) {
                setIsSticky(false);
                setLightBackground(false);
                setVisible(true);
            } else if (scrollY < headerBottom) {
                setIsSticky(true);
                setLightBackground(true);
                setVisible(true);
            } else {
                setIsSticky(true);
                setLightBackground(true);
                if (direction === 'down') {
                    setVisible(false);
                } else {
                    setVisible(true);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [headerBottom]);

    const handleGoToServicePage = (): void => {
        navigate("/skidservice");
    };

    const handleGoToHome = (): void => {
        navigate("/");
    };

    let topSectionClass = "top-section";
    if (isSticky) {
        topSectionClass += " sticky";
        if (lightBackground) {
            topSectionClass += " sticky-light";
        }
        if (!visible) {
            topSectionClass += " hidden";
        }
    }

    return (
        <div className="header-container" ref={headerRef}>
            <section className={topSectionClass}>
                <button onClick={handleGoToHome} className="logo-button" aria-label="Till startsidan">
                    <img className="logo-image" src={Logo} alt="Alpine Sport logo" />
                </button>
                <Nav />
            </section>
            <section className="bottom-section">
                <BigButton
                    text="Boka Service"
                    onClick={handleGoToServicePage}
                    className="header-btn"
                />
                <h1 className="h1-header">Professionell skidservice i Kristinehamn</h1>
            </section>
        </div>
    );
};

export default Header;
